import { GSLAUploadRow } from '../types/bulkGslaTypes';
import { getAllTierValues } from 'src/types/WarehouseHandlingTier';

// Standard handling tiers
const standardTiers = getAllTierValues();

export const parseCSV = (csvText: string): GSLAUploadRow[] => {
    const rows = csvText.split('\n');
    const headers = rows[0].split(',').map(h => h.trim());

    // Get header indices
    const headerMap = new Map<string, number>();
    headers.forEach((header, index) => {
        headerMap.set(header.toLowerCase(), index);
    });

    // Validate required headers
    const requiredHeaders = ['warehouseId', 'productionCapability', 'handlingTier', 'actualGSLA', 'recommendedGSLA', 'overrideValue'];
    const missingHeaders = requiredHeaders.filter(header => !headerMap.has(header.toLowerCase()));
    
    if (missingHeaders.length > 0) {
        throw new Error(`Invalid CSV format. Missing headers: ${missingHeaders.join(', ')}`);
    }

    // Parse data rows
    return rows.slice(1)
        .filter(row => row.trim()) // Remove empty rows
        .map((row, rowIndex) => {
            const values = row.split(',').map(v => v.trim());
            
            const warehouseId = values[headerMap.get('warehouseid')!];
            const productionCapability = values[headerMap.get('productioncapability')!];
            const handlingTier = values[headerMap.get('handlingtier')!];
            const actualGSLA = values[headerMap.get('actualgsla')!];
            const recommendedGSLA = values[headerMap.get('recommendedgsla')!];
            const overrideValue = values[headerMap.get('overridevalue')!];

            // Validate handling tier
            if (!standardTiers.includes(handlingTier)) {
                throw new Error(`Invalid handling tier '${handlingTier}' at row ${rowIndex + 2}. Must be one of: ${standardTiers.join(', ')}`);
            }

            return {
                warehouseId,
                productionCapability,
                actualGSLA,
                recommendedGSLA,
                overrideValue,
                warehouseHandlingTier: handlingTier
            };
        });
};

export const validateData = (data: GSLAUploadRow[]): boolean => {
    return data.every(row => {
        // Check if warehouseId, productionCapability, and warehouseHandlingTier are not empty
        if (!row.warehouseId || !row.productionCapability || !row.warehouseHandlingTier) {
            return false;
        }

        // Check if GSLA values are valid numbers when present
        if (row.actualGSLA && isNaN(Number(row.actualGSLA))) {
            return false;
        }
        if (row.recommendedGSLA && isNaN(Number(row.recommendedGSLA))) {
            return false;
        }

        return true;
    });
};
